import React from 'react';
interface Column<T> {
  key: string;
  header: string;
  render?: (item: T) => React.ReactNode;
  className?: string;
}
interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  keyExtractor: (item: T) => string;
  onRowClick?: (item: T) => void;
  emptyMessage?: string;
}
export function Table<T>({
  columns,
  data,
  keyExtractor,
  onRowClick,
  emptyMessage = 'No hay datos disponibles'
}: TableProps<T>) {
  if (!data || data.length === 0) {
    return <div className="text-center py-14 text-gray-400 dark:text-gray-500 text-sm" data-id="element-5495">
        {emptyMessage}
      </div>;
  }
  const safeRender = (value: unknown): React.ReactNode => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return String(value);
    if (value instanceof Date) return value.toLocaleDateString();
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
  };
  return <div className="overflow-x-auto" data-id="element-5496">
      <table className="w-full border-separate border-spacing-0" data-id="element-5497">
        <thead data-id="element-5498">
          <tr data-id="element-5499">
            {columns.map((column, i) => <th key={column.key} className={`
                  px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-widest
                  text-gray-400 dark:text-gray-500
                  bg-gray-50/80 dark:bg-white/[0.02]
                  border-b border-gray-100 dark:border-white/[0.05]
                  ${i === 0 ? 'rounded-tl-xl' : ''}
                  ${i === columns.length - 1 ? 'rounded-tr-xl' : ''}
                  ${column.className || ''}
                `} data-id="element-5500">
              
                {column.header}
              </th>)}
          </tr>
        </thead>
        <tbody data-id="element-5501">
          {data.map((item, rowIndex) => <tr key={keyExtractor(item)} onClick={() => onRowClick?.(item)} className={`
                group
                transition-colors duration-150
                ${onRowClick ? 'cursor-pointer' : ''}
                ${onRowClick ? 'hover:bg-gray-50/80 dark:hover:bg-white/[0.025]' : ''}
                ${rowIndex % 2 === 0 ? 'bg-white dark:bg-transparent' : 'bg-gray-50/50 dark:bg-white/[0.01]'}
              `} data-id="element-5502">
            
              {columns.map(column => <td key={column.key} className={`
                    px-4 py-3.5 text-sm
                    text-gray-700 dark:text-gray-200
                    border-b border-gray-50 dark:border-white/[0.03]
                    ${column.className || ''}
                  `} data-id="element-5503">
              
                  {column.render ? column.render(item) : safeRender((item as Record<string, unknown>)[column.key])}
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </div>;
}